import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ 'emptyMessage', 'cards' ];
  static values = { framesSize: Number };

  connect() {
    this.updateEmptyMessage();

    this.markAsInitializedAllFrames();
    const observer = new MutationObserver(() => this.updateFramesSize());
    observer.observe(this.cardsTarget, { subtree: true, childList: true });
  }

  markAsInitializedAllFrames() {
    this.cardsTarget.querySelectorAll('turbo-frame').forEach((turboFrame) => turboFrame._initialized = true);
  }

  newFrame(ev) {
    ev.preventDefault();
    ev.stopPropagation();

    let containers = this.cardsTarget.parentElement,
      turboFrames = containers.querySelectorAll('div[data-containers-turbo-target] > turbo-frame'),
      turboFramesLoaded = [...turboFrames].reduce((previousValue, turboFrame) => previousValue &= turboFrame._initialized, true);

    if (turboFrames.length > 0 && !turboFramesLoaded)
      return;

    let $el = ev.currentTarget,
      url = $el.href,
      turboFrameName = $el.dataset.turboFrame,
      uid = parseInt(Math.random() * 100000000),
      id = `${turboFrameName}_${uid}`;

    this.cardsTarget.insertAdjacentHTML('beforeEnd', `
      <turbo-frame id="${id}" src="${url.replace('replace-me', uid)}">
        Carregando <span class="loading"></span>
      </turbo-frame>
    `);

    let lastTurboFrame = containers.querySelector('div[data-containers-turbo-target] > turbo-frame:last-child');
    !!lastTurboFrame && lastTurboFrame.loaded.then(() => { lastTurboFrame._initialized = true });
  }

  updateFramesSize() {
    this.framesSizeValue = this.cardsTarget.querySelectorAll('turbo-frame').length
  }

  framesSizeValueChanged() {
    this.updateEmptyMessage();
  }

  updateEmptyMessage() {
    this.emptyMessageTarget.classList.toggle('hidden', this.framesSizeValue > 0);
    this.cardsTarget.classList.toggle('hidden', this.framesSizeValue == 0);
  }
}